// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__kSaip","buttons":"PendingPaymentAlert_buttons__3WPvl"};